<template>
    <div class="about">
        <Banner></Banner>
        <div class="m-main">
            <h2 class="u-hello">
                {{qsName}}，
                <span>参选报名情况：</span>
            </h2>
            <div class="m-part2">
                <List :ListArr="ListDatas"></List>
                <div class="m-industry-box3">
                    <router-link to="/home" class="u-industry-btn2 fl">返回</router-link>
                    <!-- <span class="u-industry-btn2 fr" @click="doPrintVue">报名情况打印</span> -->
                    <router-link to="/print" class="u-industry-btn2 fr">报名情况打印</router-link>
                </div>
            </div>
        </div>
        <Foot></Foot>
    </div>
</template>
<script>
import Banner from "@/components/Banner";
import List from "@/components/List";
import Foot from "@/components/Footer";
export default {
    components: {
        Banner,
        List,
        Foot
    },
    data() {
        return {
            qsName: "",
            ListDatas: [
                // {
                //     num: 1,
                //     name: "通信行业（5G）",
                //     leader: "冯国璋（首席）",
                //     member:
                //         "常福强、张仙、张恒星、凌晨、王曦、常福强、张仙、张恒星、凌晨、王曦"
                // },
                // {
                //     num: 2,
                //     name: "通信行业（5G）",
                //     leader: "冯国璋（首席）",
                //     member:
                //         "常福强、张仙、张恒星、凌晨、王曦、常福强、张仙、张恒星、凌晨、王曦"
                // }
            ]
        };
    },
    created() {
        this.detection();
        this.getLists();
    },
    methods: {
        getLists() {
            var _this = this;
            let param = {
                url:
                    "//support.finance.sina.com.cn/service/api/openapi.php/JinQiService.getQsInfo",
                // ?acode=ajzq_020235f9c2af&atype=qs&hy_id=1
                acode: sessionStorage.getItem("acode"),
                atype: "qs"
            };
            // 发送 POST 请求
            this.$jsonp(param.url, {
                acode: param.acode,
                atype: param.atype
            })
                .then(function(response) {
                    // console.log(response);
                    if (response.result.status.code == 0) {
                        let datas = response.result.data;
                        _this.ListDatas = datas.hy;
                        _this.qsName = datas.qs.name;
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        detection() {
            let name = sessionStorage.getItem("name");
            // alert(name);
            if (!name) {
                this.$router.push({ path: "/" });
            }
        }
        // doPrintVue() {
        //     //          var newstr = document.getElementById('printOrder').innerHTML
        //     //   // 2. 复制给body，并执行window.print打印功能
        //     //   document.body.innerHTML = newstr
        //     //   // 3. 还原：将旧的页面储存起来，当打印完成后返给给页面。
        //     //   var oldstr = document.body.innerHTML
        //     //   window.print()
        //     //   document.body.innerHTML = oldstr
        //     //   return false
        //     var newstr = document.getElementById("printOrder").innerHTML;
        //     document.body.innerHTML = newstr;
        //     window.print();
        //     // 重新加载页面，以刷新数据
        //     window.location.reload();
        // }
    }
};
</script>
<style lang="scss" scoped>
.m-part2 {
    margin-top: 20px;
}
</style>